// extracted by mini-css-extract-plugin
export default {"framework-selector":"V_ct d-flex","framework-selector__icon":"V_cv","framework-selector__option":"V_cw p-2 flex-grow-1 ml-2","framework-selector__option--selected":"V_cx"};